import React from 'react';

const Button = (props) => {
  const {
    type = 'button',
    text,
    disabled,
    loading,
    icon = null,
    onClick,
    classType = 'btn-primary',
    className = '',
    style = {},
    testId,
    title = '',
  } = props;
  const spinner = !loading ? null : (
    <span
      className="spinner-border spinner-border-sm mr-1"
      data-testid="status"
      role="status"
      aria-hidden="true"
    ></span>
  );
  return (
    <button
      type={type}
      style={style}
      className={`btn ${classType} ${className}`}
      disabled={disabled}
      onClick={onClick || null}
      data-testid={testId}
      title={title}
    >
      {spinner}
      {!spinner && icon ? (
        <i data-testid="btnIconTestId" className={`${icon} ${text ? 'mr-1' : ''}`} />
      ) : null}
      {text}
    </button>
  );
};

export default Button;
